import styled, { css } from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--space-300);
`;
export const Bar = styled.div `
  height: var(--space-500);
  background: var(--bg-brand);
  min-width: var(--space-50);
  border-radius: var(--radius-brand);
  width: ${({ $width }) => `${$width}%`};
  transform-origin: left center;
  will-change: transform;

  ${({ $color }) => $color &&
    css `
      background: ${$color};
    `};

  ${({ $animation, $isAnimated }) => $animation &&
    css `
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      transform: ${$isAnimated ? 'scaleX(1)' : 'scaleX(0)'};
    `};
`;
export const Value = styled.div `
  color: var(--text-primary);
  text-align: right;
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
  position: relative;
  will-change: transform;

  ${({ $animation, $isAnimated }) => $animation &&
    css `
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      transform: ${$isAnimated ? 'translateX(0)' : 'translateX(-100%)'};
    `};
`;
